const state = () => ({
  userInfo:null,
})
export default state
